import React, { Component } from 'react';
import { get } from 'lodash';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Form } from 'informed';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
import InputTextArea from '../../components/inputs/InputTextArea';
import Loading from '../../components/Loading';
import { API_HOST } from '../../consts';
import AddButton from '../../components/buttons/AddButton';

class Competencia extends Component {
  constructor(props) {
    super(props);
    this.id = get(props, 'match.params.id');
  }

  state = {
    submitting: false,
    loading: true,
    metadata: {},
  }

  componentDidMount() {
    this.fetchData();
    this.fetchMetadata();
  }

  metadataModels = ['matriz'];

  fetchMetadata() {
    this.setState({ fetchingMetadata: true });
    return axios
      .get(`${API_HOST}/params/param?model=${this.metadataModels.join('|')}`)
      .then((response) => {
        this.setState({
          metadata: this.mapMetadata(response.data),
          fetchingMetadata: false
        });
      });
  }


  mapMetadata(metadata) {
    const mapped = {};
    metadata &&
      metadata
        .filter((d) => d.is_active === true)
        .forEach((m) => {
          mapped[`${m.model}.${m.name}`] = m.default;
        });
    return mapped;
  }


  shouldDisplayDefault(field) {
    const { metadata } = this.state;
    return get(metadata, field);
  }

  fetchData = () => {
    if (this.id !== 'new') {
      axios.get(`${API_HOST}/matriz_referencia/competencia/${this.id}`)
        .then((response) => {
          this.formApi.setValues({
            descricao: response.data.descricao,
          });
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false });
    }
  }

  handleError = (error) => {
    if (get(error, 'response.status') === 400) {
      get(error, 'response.data.descricao', []).forEach(e => (
        toast.error(e)
      ));
    } else {
      toast.error('Por favor, preencha corretamente todos os campos.');
    }
    this.setState({ submitting: false });
  }

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    if (this.id === 'new') {
      axios.post(`${API_HOST}/matriz_referencia/competencia`, values)
        .then(() => {
          const { history } = this.props;
          toast.success(`${this.shouldDisplayDefault('matriz.competencia') || 'Competência'} criada com sucesso.`);
          history.push('/competencias');
        })
        .catch(this.handleError);
    } else {
      axios.patch(`${API_HOST}/matriz_referencia/competencia/${this.id}`, values)
        .then(() => {
          const { history } = this.props;
          toast.success(`${this.shouldDisplayDefault('matriz.competencia') || 'Competência'} atualizada com sucesso.`);
          history.push('/competencias');
        })
        .catch(this.handleError);
    }
  }

  render() {
    const competencia = this.shouldDisplayDefault('matriz.competencia') || 'Competência';
    const pathList = [
      { link: '/competencias', label: `${competencia}s` },
    ];
    const currentPath = this.id === 'new' ? `${this.shouldDisplayDefault('matriz.competencia') ? 'Novo' : 'Nova'} ${competencia}` : `${competencia} ${this.id}`;
    const { submitting, loading } = this.state;

    return (
      <div className="form-configuracoes">
        <NavBreadCrumb pathList={pathList} currentPath={currentPath} />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <Form
                  onSubmit={this.handleSubmit}
                  getApi={(formApi) => { this.formApi = formApi; }}
                >
                  {() => {
                    if (loading) {
                      return <Loading />;
                    }

                    return (
                      <>
                        <div className="card-header">
                          <div className="row">
                            <div className="col-6">
                              {this.id === 'new' ? <h1>{this.shouldDisplayDefault('matriz.competencia') ? 'Novo' : 'Nova'} {competencia}</h1> : <h1>{competencia} <b>{this.id}</b></h1>}
                            </div>
                          </div>
                        </div>
                        <div className="card-body card-body-form">
                          <InputTextArea
                            field="descricao"
                            label="Descrição"
                          />
                        </div>
                        <div className="card-footer display-flex">
                          <AddButton
                            type="submit"
                            disabled={submitting}
                            title="Salvar"
                            noIcon
                          />
                        </div>
                      </>
                    );
                  }}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Competencia;
